export default "/images/close-small.svg?c56170273c8cbe1bc5e75f2b1b4c3807";